var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"mobile-breakpoint":"0"},scopedSlots:_vm._u([{key:"item.created",fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm._f("datetime")(item.created)))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }